import React from 'react';
import '../../styles/components/last_updated_status.css';

export interface LastUpdatedStatusSegment {
  label: string;
  value: string;
}

interface LastUpdatedStatusProps {
  /**
   * Extra label/value segments rendered before "Last updated" — e.g.
   * "Organization" / "Created on" on User Analytics and the Company
   * drill-down. Omit for pages (like Logs) that only need the timestamp.
   */
  segments?: LastUpdatedStatusSegment[];
}

const formatLastUpdated = (date: Date): string =>
  date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

/**
 * Page-header status row: any `segments` first, then "Last updated" + the
 * current timestamp + a green "live" dot. Shared by User Analytics, the
 * Company drill-down, and the Logs page — previously duplicated inline on
 * each.
 */
const LastUpdatedStatus: React.FC<LastUpdatedStatusProps> = ({ segments = [] }) => (
  <div className="lus-row">
    {segments.map((segment) => (
      <React.Fragment key={segment.label}>
        <span className="lus-label">{segment.label}</span>
        <span className="lus-timestamp">{segment.value}</span>
        <span className="lus-divider" />
      </React.Fragment>
    ))}
    <span className="lus-label">Last updated</span>
    <span className="lus-timestamp">{formatLastUpdated(new Date())}</span>
    <span className="lus-dot" />
  </div>
);

export default LastUpdatedStatus;
